import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Leaf, Heart, Sparkles, ArrowRight, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
const Index = () => {
  return <div className="min-h-screen bg-gradient-to-br from-background via-secondary/30 to-accent/20 flex items-center justify-center p-4">
      <Card className="w-full max-w-4xl shadow-zen">
        <CardHeader className="text-center space-y-6">
          <div className="flex justify-center">
            <div className="p-4 bg-gradient-to-br from-primary/10 to-accent/10 rounded-full">
              <Leaf className="w-12 h-12 text-primary" />
            </div>
          </div>
          <CardTitle className="text-4xl font-bold bg-gradient-zen bg-clip-text text-transparent">
            北欧×禅 しあわせ診断センター
          </CardTitle>
          <p className="text-lg text-muted-foreground leading-relaxed">
            あなたの心の状態としあわせタイプを知るための2つの診断をご用意しています。<br />
            北欧の自然と禅の静寂を取り入れた空間で、ご自分を見つめ直してみませんか？
          </p>
        </CardHeader>
        <CardContent className="space-y-8">
          <div className="grid md:grid-cols-2 gap-6">
            {/* 第1の診断 */}
            <Card className="border-2 hover:border-primary/50 transition-colors cursor-pointer group">
              <CardHeader className="text-center space-y-4">
                <div className="flex justify-center">
                  <div className="p-3 bg-gradient-to-br from-primary/10 to-accent/10 rounded-full group-hover:scale-110 transition-transform">
                    <Heart className="w-8 h-8 text-primary" />
                  </div>
                </div>
                <CardTitle className="text-xl">北欧しあわせ体質診断</CardTitle>
                <p className="text-sm text-muted-foreground">
                  20の質問であなたの心の状態を詳しく分析します。<br />
                  5タイプの診断結果で具体的なアドバイスを提供。
                </p>
              </CardHeader>
              <CardContent>
                <Link to="/detailed-diagnosis">
                  <Button className="w-full bg-gradient-zen hover:opacity-90 transition-zen" size="lg">
                    詳細診断を始める
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <div className="mt-4 text-xs text-muted-foreground text-center">
                  所要時間: 約10分 | 質問数: 20問
                </div>
              </CardContent>
            </Card>

            {/* 第2の診断 */}
            <Card className="border-2 hover:border-primary/50 transition-colors cursor-pointer group">
              <CardHeader className="text-center space-y-4">
                <div className="flex justify-center">
                  <div className="p-3 bg-gradient-to-br from-accent/10 to-primary/10 rounded-full group-hover:scale-110 transition-transform">
                    <Sparkles className="w-8 h-8 text-primary" />
                  </div>
                </div>
                <CardTitle className="text-xl">北欧しあわせ体質チェック</CardTitle>
                <p className="text-sm text-muted-foreground">選択式質問であなたのしあわせタイプを簡単診断。日常生活に活かせるヒントをお届けします。</p>
              </CardHeader>
              <CardContent>
                <Link to="/happiness-check">
                  <Button className="w-full bg-gradient-nature hover:opacity-90 transition-zen" size="lg">
                    簡単チェックを始める
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
                <div className="mt-4 text-xs text-muted-foreground text-center">
                  所要時間: 約5分 | 質問数: 10問
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center space-y-4">
            <div className="bg-muted/50 p-6 rounded-lg">
              <h3 className="font-semibold mb-3 text-lg">こんな方におすすめ</h3>
              <div className="grid md:grid-cols-2 gap-4 text-sm text-muted-foreground">
                <div>
                  <h4 className="font-medium text-foreground mb-2">詳細診断がおすすめの方</h4>
                  <ul className="space-y-1 text-left">
                    <li>・ 最近心の不調を感じている</li>
                    <li>・ 自分の状態を詳しく知りたい</li>
                    <li>・ 具体的な改善方法を知りたい</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-foreground mb-2">簡単チェックがおすすめの方</h4>
                  <ul className="space-y-1 text-left">
                    <li>・ 時間をかけずに診断したい</li>
                    <li>・ 自分のしあわせタイプを知りたい</li>
                    <li>・ 日常に活かせるヒントが欲しい</li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* 外部サイトへの戻るボタン */}
            <div className="mt-8 pt-6 border-t border-muted text-center">
              <a 
                href="https://hokuou-wellbeing.jp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block"
              >
                <Button 
                  variant="outline" 
                  className="bg-gradient-zen hover:opacity-90 transition-zen text-white border-none"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  北欧ウェルビーイングに戻る
                </Button>
              </a>
            </div>

          </div>
        </CardContent>
      </Card>
    </div>;
};
export default Index;